import { BRIDGE_EVENT } from '../constants'

export function createEvent(detail: any): CustomEvent {
  return new CustomEvent(BRIDGE_EVENT, { detail })
}
